import { useMemo } from "react";
import { RICH_BLOCK_LANGUAGES } from "@/features/chat/components/rich-blocks/parse";

const LANG_PATTERN = Array.from(RICH_BLOCK_LANGUAGES).join("|");
const OPEN_FENCE_RE = new RegExp("```(" + LANG_PATTERN + ")\\n");
const CLOSE_FENCE_RE = /```\s*$/;

/**
 * Detects whether the streaming message currently has an unclosed rich block.
 * Returns the block type being written, or null if no block is in progress.
 */
export function useStreamingBlocks(content: string, isStreaming: boolean): { activeBlock: string | null } {
  return useMemo(() => {
    if (!isStreaming || !content) return { activeBlock: null };

    // Find the last opening fence
    let lastMatch: RegExpExecArray | null = null;
    const re = new RegExp(OPEN_FENCE_RE.source, "g");
    let match: RegExpExecArray | null;

    while ((match = re.exec(content)) !== null) {
      lastMatch = match;
    }

    if (!lastMatch) return { activeBlock: null };

    // Check if there's a closing fence after the last opening fence
    const afterOpen = content.slice(lastMatch.index + lastMatch[0].length);
    if (CLOSE_FENCE_RE.test(afterOpen)) return { activeBlock: null };

    return { activeBlock: lastMatch[1]! };
  }, [content, isStreaming]);
}
